<plex-text [(ngModel)]="filtroPaciente" (ngModelChange)="filtrarPaciente()"
           placeholder="Escriba un documento / apellido / nombre">
    <plex-icon name="account-search" left></plex-icon>
</plex-text>

<div *ngIf="pacientes.length" class="flex-grow-1">
    <auditoria-listado [pacientes]="pacientes" [registroReportes]="reportes" [autoselect]="false" [errorTab]="true"
                       (selected)="onSelect($event)" (scrolled)="onScroll()" (resetReport)="onResetReport($event)">
    </auditoria-listado>

    <div *ngIf="loading" class="loading-overlay">
        <plex-loader type="ball-pulse"></plex-loader>
    </div>
</div>
<div *ngIf="!loading && !pacientes.length" class="alert alert-default">
    <plex-icon name="emoticon-happy"></plex-icon> No se encontraron pacientes con datos reportados.
</div>

<modal-correccion-paciente #modalCorreccion [paciente]="pacienteSelected" (patientCorrected)="savePatient($event)">
</modal-correccion-paciente>